import React, {Component} from 'react';

const LocalizationContext = React.createContext({});

class LocalizationContextProvider extends Component {
    render() {
        return (
            <LocalizationContext.Provider value={this.props.siteContext}>
                {this.props.children}
            </LocalizationContext.Provider>
        );
    }
}

export {LocalizationContext, LocalizationContextProvider};
